require('fslightbox');
import { getMeta } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import BlockAsyncController from './controllers/block-async-controller';
import DatePickerController from './controllers/date-picker-controller';
import AutocompleteController from './controllers/autocomplete-controller';
import LeafletMapsController from './controllers/leaflet-maps-controller';

require('./phone-input');

const application = Application.start();

application.register('block-async', BlockAsyncController);
application.register('axios-form', AxiosFormController);
application.register('date-picker', DatePickerController);
application.register('autocomplete', AutocompleteController);
application.register('map', LeafletMapsController);
